import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
  }
  
  submitForm(event) {
    // Wait for checkbox to be toggled by the label
    setTimeout(() => {
      // Use requestSubmit() to trigger Turbo's form handling
      this.element.requestSubmit();
    }, 50);
  }
}